<template>
  
  <div id="app-loading"></div>

</template>

<script>
export default{



}
</script>

<style scoped>
#app-loading{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 1000;
}
#app-loading::after{
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 25px;
  height: 25px;
  border: 2px solid black;
  border-radius: 50%;
  border-top-color: transparent;
  border-bottom-color: transparent;
  z-index: 2;
  animation: spin-loader .4s linear infinite;
}
</style>
